import { connect } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState } from '@mews-commander/types';
import EnterpriseBuilderScreenStep from '../../EnterpriseBuilderScreenStep';
import EntityManager from '../../../entityManagement/components/EntityManager';
import { changeStep } from '../../actions/steps';

const Dashboard = EntityManager({
    Title: <LocalizedText textKey={TextKey.Dashboard} />,
});

export default connect<{}, { onAdd: () => void }, { scope: string }, ApplicationState>(undefined, (dispatch) => ({
    onAdd: () => dispatch(changeStep(EnterpriseBuilderScreenStep.Enterprise)),
}))(Dashboard);
